import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import SafariBlog from '../../components/SafariBlog/SafariBlog'

import gallery_1 from '../../assets/images/wilpattu-park-1.webp'
import gallery_2 from '../../assets/images/wilpattu-park-2.webp'
import gallery_3 from '../../assets/images/wilpattu-park-3.webp'
import gallery_4 from '../../assets/images/wilpattu-park-4.jpg'
import gallery_5 from '../../assets/images/wilpattu-park-5.webp'
import gallery_6 from '../../assets/images/wilpattu-park-6.webp'
import gallery_7 from '../../assets/images/wilpattu-park-7.webp'
import gallery_8 from '../../assets/images/wilpattu-park-8.webp'
import gallery_9 from '../../assets/images/wilpattu-park-9.webp'
import gallery_10 from '../../assets/images/wilpattu-park-10.webp'
import gallery_11 from '../../assets/images/wilpattu-park-11.webp'
import gallery_12 from '../../assets/images/wilpattu-park-12.webp'


const descriptions = [
    'Wilpattu National Park is in northwest Sri Lanka. It’s the biggest national park there, covering 1,317 square kilometers. The park has different habitats like jungles, lakes, and grasslands, which provide homes for many plants and animals.',

    'The park has a lot of different animals. Leopards, which are graceful and sneaky, live there. Elephants walk around, and deer roam the grasslands. Sloth bears, with their shaggy coats, also live there, adding some fun to the park.',

    'Wilpattu is also great for birdwatching. There are lots of lakes where birds hang out, both those that live there all the time and those that visit during certain times of the year. You can see colorful kingfishers and majestic eagles flying around.',

    'Going on a safari in Wilpattu is really cool. You get to see animals in their natural homes, and the park is so beautiful. You never know what you might see next, like a leopard hiding or elephants playing in the water.',

    'It’s important to take care of Wilpattu. We should all work together to keep the park safe for plants and animals. Let’s explore, enjoy, and help protect Wilpattu National Park, where nature’s beauty shines bright.',
  ];

const wildlife_photography = () => {

    const items = [
        { xs: 4, imgSrc: gallery_1 },
        { xs: 4, imgSrc: gallery_2 },
        { xs: 4, imgSrc: gallery_3 },
        { xs: 2, imgSrc: gallery_4 },
        { xs: 2, imgSrc: gallery_5 },
        { xs: 4, imgSrc: gallery_6 },
        { xs: 4, imgSrc: gallery_7 },
        { xs: 4.5, imgSrc: gallery_8 },
        { xs: 2, imgSrc: gallery_9 },
        { xs: 5.5, imgSrc: gallery_10 },
        { xs: 4, imgSrc: gallery_11 },
        { xs: 4, imgSrc: gallery_12 },
    ];

  return <div className='__black'>
    <SafariBlog
        heading='Wilpattu National Park'
        description={descriptions}
        to='/contact'
    />
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'40vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography